import { __decorate, __param } from 'tslib';
import { Inject, Input, HostBinding, HostListener, Component, ChangeDetectionStrategy, NgModule } from '@angular/core';
import { TuiDestroyService, TUI_IS_MOBILE, tuiDefaultProp } from '@taiga-ui/cdk';
import { TUI_HINT_OPTIONS } from '@taiga-ui/core/directives';
import { MODE_PROVIDER } from '@taiga-ui/core/providers';
import { TUI_MODE } from '@taiga-ui/core/tokens';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { TuiSvgModule } from '@taiga-ui/core/components/svg';
import { TuiHintModule } from '@taiga-ui/core/directives/hint';
import { PolymorpheusModule } from '@tinkoff/ng-polymorpheus';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@tinkoff/ng-polymorpheus';
import * as ɵngcc2 from '@taiga-ui/core/directives/hint';
import * as ɵngcc3 from '@taiga-ui/core/components/svg';
import * as ɵngcc4 from 'rxjs';

function TuiTooltipComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "tui-svg", 1);
} if (rf & 2) {
    const icon_r1 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("src", icon_r1);
} }
let TuiTooltipComponent = class TuiTooltipComponent {
    constructor(destroy$, mode$, isMobile, options) {
        this.isMobile = isMobile;
        this.options = options;
        this.globalMode = null;
        this.content = '';
        this.mode = this.options.mode;
        this.direction = this.options.direction;
        this.showDelay = this.options.tuiHintShowDelay;
        this.hideDelay = this.options.tuiHintHideDelay;
        this.describeId = '';
        mode$.pipe(takeUntil(destroy$)).subscribe(mode => {
            this.globalMode = mode;
        });
    }
    // TODO: Simplify
    get computedMode() {
        return this.mode || (this.globalMode === 'onDark' ? 'onDark' : null);
    }
    stopOnMobile(event) {
        if (this.isMobile) {
            event.preventDefault();
            event.stopPropagation();
        }
    }
    get icon() {
        return this.options.tooltipIcon;
    }
};
TuiTooltipComponent.ɵfac = function TuiTooltipComponent_Factory(t) { return new (t || TuiTooltipComponent)(ɵngcc0.ɵɵdirectiveInject(TuiDestroyService), ɵngcc0.ɵɵdirectiveInject(TUI_MODE), ɵngcc0.ɵɵdirectiveInject(TUI_IS_MOBILE), ɵngcc0.ɵɵdirectiveInject(TUI_HINT_OPTIONS)); };
TuiTooltipComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TuiTooltipComponent, selectors: [["tui-tooltip"]], hostVars: 1, hostBindings: function TuiTooltipComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("mousedown", function TuiTooltipComponent_mousedown_HostBindingHandler($event) { return ctx.stopOnMobile($event); })("click", function TuiTooltipComponent_click_HostBindingHandler($event) { return ctx.stopOnMobile($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("data-mode", ctx.computedMode);
    } }, inputs: { content: "content", mode: "mode", direction: "direction", showDelay: "showDelay", hideDelay: "hideDelay", describeId: "describeId" }, features: [ɵngcc0.ɵɵProvidersFeature([TuiDestroyService, MODE_PROVIDER])], decls: 2, vars: 7, consts: [["polymorpheus-outlet", "", "automation-id", "tui-tooltip__icon", 1, "icon", 3, "content", "tuiHintId", "tuiHint", "tuiHintDirection", "tuiHintShowDelay", "tuiHintHideDelay", "tuiHintMode"], [3, "src"]], template: function TuiTooltipComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "span", 0);
        ɵngcc0.ɵɵtemplate(1, TuiTooltipComponent_ng_template_1_Template, 1, 1, "ng-template");
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("content", ctx.icon)("tuiHintId", ctx.describeId)("tuiHint", ctx.content)("tuiHintDirection", ctx.direction)("tuiHintShowDelay", ctx.showDelay)("tuiHintHideDelay", ctx.hideDelay)("tuiHintMode", ctx.computedMode);
    } }, directives: [ɵngcc1.PolymorpheusOutletComponent, ɵngcc2.TuiHintDirective, ɵngcc3.TuiSvgComponent], styles: ["[_nghost-%COMP%]{transition-property:color;transition-duration:var(--tui-duration,300ms);transition-timing-function:ease-in-out;position:relative;display:inline-block;width:1.5rem;height:1.5rem;vertical-align:middle;font-size:0;line-height:0;cursor:pointer;color:var(--tui-text-03)}[_nghost-%COMP%]:hover{color:var(--tui-text-02)}[data-mode=onDark][_nghost-%COMP%]{color:var(--tui-text-01-night)}[data-mode=onLight][_nghost-%COMP%]{color:var(--tui-text-01)}[data-mode=error][_nghost-%COMP%]{color:var(--tui-error-fill)}.icon[_ngcontent-%COMP%]{transition-property:opacity,color;transition-duration:var(--tui-duration,300ms);transition-timing-function:ease-in-out;display:inline-block;width:100%;height:100%}[_nghost-%COMP%]:not([data-mode])   .icon._hint_hovered[_ngcontent-%COMP%]{color:var(--tui-text-02)}[data-mode=onDark][_nghost-%COMP%]   .icon[_ngcontent-%COMP%], [data-mode=onLight][_nghost-%COMP%]   .icon[_ngcontent-%COMP%]{opacity:var(--tui-disabled-opacity)}[data-mode=onDark][_nghost-%COMP%]   .icon._hint_hovered[_ngcontent-%COMP%], [data-mode=onDark][_nghost-%COMP%]   .icon[_ngcontent-%COMP%]:hover, [data-mode=onLight][_nghost-%COMP%]   .icon._hint_hovered[_ngcontent-%COMP%], [data-mode=onLight][_nghost-%COMP%]   .icon[_ngcontent-%COMP%]:hover{opacity:1}"], changeDetection: 0 });
TuiTooltipComponent.ctorParameters = () => [
    { type: Observable, decorators: [{ type: Inject, args: [TuiDestroyService,] }] },
    { type: Observable, decorators: [{ type: Inject, args: [TUI_MODE,] }] },
    { type: Boolean, decorators: [{ type: Inject, args: [TUI_IS_MOBILE,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [TUI_HINT_OPTIONS,] }] }
];
__decorate([
    Input(),
    tuiDefaultProp()
], TuiTooltipComponent.prototype, "content", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiTooltipComponent.prototype, "mode", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiTooltipComponent.prototype, "direction", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiTooltipComponent.prototype, "showDelay", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiTooltipComponent.prototype, "hideDelay", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiTooltipComponent.prototype, "describeId", void 0);
__decorate([
    HostBinding('attr.data-mode')
], TuiTooltipComponent.prototype, "computedMode", null);
__decorate([
    HostListener('mousedown', ['$event']),
    HostListener('click', ['$event'])
], TuiTooltipComponent.prototype, "stopOnMobile", null);
TuiTooltipComponent = __decorate([ __param(0, Inject(TuiDestroyService)),
    __param(1, Inject(TUI_MODE)),
    __param(2, Inject(TUI_IS_MOBILE)),
    __param(3, Inject(TUI_HINT_OPTIONS))
], TuiTooltipComponent);

let TuiTooltipModule = class TuiTooltipModule {
};
TuiTooltipModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: TuiTooltipModule });
TuiTooltipModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function TuiTooltipModule_Factory(t) { return new (t || TuiTooltipModule)(); }, imports: [[CommonModule, TuiSvgModule, TuiHintModule, PolymorpheusModule]] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiTooltipComponent, [{
        type: Component,
        args: [{
                selector: 'tui-tooltip',
                template: "<span\n    polymorpheus-outlet\n    automation-id=\"tui-tooltip__icon\"\n    class=\"icon\"\n    [content]=\"icon\"\n    [tuiHintId]=\"describeId\"\n    [tuiHint]=\"content\"\n    [tuiHintDirection]=\"direction\"\n    [tuiHintShowDelay]=\"showDelay\"\n    [tuiHintHideDelay]=\"hideDelay\"\n    [tuiHintMode]=\"computedMode\"\n>\n    <ng-template let-icon>\n        <tui-svg [src]=\"icon\"></tui-svg>\n    </ng-template>\n</span>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                providers: [TuiDestroyService, MODE_PROVIDER],
                styles: [":host{transition-property:color;transition-duration:var(--tui-duration,300ms);transition-timing-function:ease-in-out;position:relative;display:inline-block;width:1.5rem;height:1.5rem;vertical-align:middle;font-size:0;line-height:0;cursor:pointer;color:var(--tui-text-03)}:host:hover{color:var(--tui-text-02)}:host[data-mode=onDark]{color:var(--tui-text-01-night)}:host[data-mode=onLight]{color:var(--tui-text-01)}:host[data-mode=error]{color:var(--tui-error-fill)}.icon{transition-property:opacity,color;transition-duration:var(--tui-duration,300ms);transition-timing-function:ease-in-out;display:inline-block;width:100%;height:100%}:host:not([data-mode]) .icon._hint_hovered{color:var(--tui-text-02)}:host[data-mode=onDark] .icon,:host[data-mode=onLight] .icon{opacity:var(--tui-disabled-opacity)}:host[data-mode=onDark] .icon._hint_hovered,:host[data-mode=onDark] .icon:hover,:host[data-mode=onLight] .icon._hint_hovered,:host[data-mode=onLight] .icon:hover{opacity:1}"]
            }]
    }], function () { return [{ type: ɵngcc4.Observable, decorators: [{
                type: Inject,
                args: [TuiDestroyService]
            }] }, { type: ɵngcc4.Observable, decorators: [{
                type: Inject,
                args: [TUI_MODE]
            }] }, { type: Boolean, decorators: [{
                type: Inject,
                args: [TUI_IS_MOBILE]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [TUI_HINT_OPTIONS]
            }] }]; }, { content: [{
            type: Input
        }], mode: [{
            type: Input
        }], direction: [{
            type: Input
        }], showDelay: [{
            type: Input
        }], hideDelay: [{
            type: Input
        }], describeId: [{
            type: Input
        }], computedMode: [{
            type: HostBinding,
            args: ['attr.data-mode']
        }], stopOnMobile: [{
            type: HostListener,
            args: ['mousedown', ['$event']]
        }, {
            type: HostListener,
            args: ['click', ['$event']]
        }] }); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TuiTooltipModule, { declarations: function () { return [TuiTooltipComponent]; }, imports: function () { return [CommonModule, TuiSvgModule, TuiHintModule, PolymorpheusModule]; }, exports: function () { return [TuiTooltipComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiTooltipModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, TuiSvgModule, TuiHintModule, PolymorpheusModule],
                declarations: [TuiTooltipComponent],
                exports: [TuiTooltipComponent]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { TuiTooltipComponent, TuiTooltipModule };

//# sourceMappingURL=taiga-ui-core-components-tooltip.js.map